<template>
  <div class="box-sem-resultados">
    <p>{{ mensagem }}</p>
  </div>
</template>

<script>
export default {
  name: "MensagemSemResultados",
  props: {
    mensagem: String
  }
};
</script>

<style lang="scss" scoped>

.box-sem-resultados {
  display: flex;
  border-radius: 4px;
  background-color: #fff;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.096); 
}

.box-sem-resultados p {
  margin: 10px;
}


</style>
